   <section class="ytb-v2-newsletter-area">
        <div class="container">
          <div class="ytb-v2-newsleter">
            <div class="row">
              <div class="col-md-6">
                <div class="ytb-newsletter-content">
                  <img src="assets/images/footer-images/email.png" alt="">
                  <h2>Subscribe today and never miss another deal again!
                  </h2>
                </div>
              </div>
              <div class="col-md-6">
                
                <form [formGroup]="emailSubsribeForm">
                    <div class="form-letter">
                        <div class="letter-input">
                            <input type="text" formControlName="email" class="form-control" placeholder="Enter email address" />

                            <span class="err-msg" *ngIf="emailSubsribeForm.get('email').touched  &&  emailSubsribeForm.get('email').hasError('email')" class="text text-danger font600">Please enter a valid email address</span>
                            <span class="err-msg text text-danger font600" *ngIf="emailSubsribeForm.get('email').touched  &&  emailSubsribeForm.get('email').hasError('required')"> Email is required </span>
                        </div>
                        <div>
           

                  <button class="btn btn-secondary " type="button" (click)="postEmailSubsribe()"><b>SUBSCRIBE</b> </button>
                </div>
            </div>
                </form>
                <div *ngIf="emailSub() ==='Email Already Existed'">
                </div>

                <div *ngIf="emailSub() ==='Your Email Sucessfully Subscribed'">
                </div>
                <!-- <p>By entering your email address, you agree to CheapOair's <a href="#">Terms and Conditions</a>, <a
                    href="#">Privacy Policy</a> and to receive email marketing.</p> -->
              </div>
            </div>
          </div>
        </div>
      </section>